import React, { useContext, useState } from 'react';
import { IDishesContext, DishesContext } from '../dishesState/dishesContext';
import { Link } from 'react-router-dom';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import { CustomPop } from 'components/Popover/CustomPop';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './AdditionalControls.module.scss';

export const AdditionalControls: React.FC = () => {
	const { changeTypeOfModalWindow } = useContext<IDishesContext>(DishesContext);
	const [open, setOpen] = useState(false);
	const iconClasses = classNames(style.icon, { [style.rotate]: open });

	const controls = (
		<div className={style.controls}>
			{/*<Link to="/menu/dishes-assignment-v2">*/}
			{/*	<Text translationNameSpace="listing" translationKey="assignmentButton" size="s" />*/}
			{/*</Link>*/}
			<div className={style.linkStyle} onClick={() => changeTypeOfModalWindow('copyMenu')}>
				<Text translationNameSpace="listing" translationKey="copyMenuButton" size="s" />
			</div>
		</div>
	);

	return (
		<div className={style.container}>
			<CustomPop childrenContent={controls} placement="top-end" setOpenStatus={setOpen}>
				<div className={style.btn}>
					<Button
						theme="primaryBlue"
						className={style.btn}
						icon={
							<svg className={iconClasses}>
								<use xlinkHref={`${breadcrumbs}#plus`} />
							</svg>
						}
					/>
				</div>
			</CustomPop>
		</div>
	);
};
